import {takeEvery, put, fork, call, all, select } from 'redux-saga/effects';
import * as rs from './reportsSlice';
import * as uis from '../../UI/redux/uiSlice';
import { authReducerActions, authSagaActions } from '../../Auth';
import { getAllReportsApi, findReportsApi } from './reportsAPI';


export function* onLoadReportsStartAsync({ payload }){

    try{
        
        yield put(rs.actions.startCall({ callType: rs.callTypes.list }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            sessionkey: auth.sessionKey,
            input: {
                ...payload.queryParams
            }
        };

        const response = yield call(getAllReportsApi, payload.deptId, reqBody);        

        if(response.status === 200){
            let totalCount = response.data.length;
            let entities = response.data;
            yield put(rs.actions.reportsFetched({totalCount, entities}));
        }
    }
    catch(error){

        console.log(error);

        if(error.response.status === 403){

            yield put(authReducerActions.loggedOut());
            
        } else {
            if(error.response.status === 404){

                let status = error.response.status;
                let msg = "Page Not Found.";

                yield put(uis.actions.error({ status, msg }));
            } else if(error.response.status === 500){

                let status = error.response.status;
                let msg = "Internal Error";

                yield put(uis.actions.error({ status, msg }));
            }

            yield put(uis.actions.showNotification({
                status:"error",
                title:"Error",
                message: "There was an error retrieving the reports."
            }));

            yield put(rs.actions.catchError({
                callType: rs.callTypes.list,
                error: "There was an error retrieving the reports."
            }));
        }
    }

};

export function* onFindReportsStartAsync({ payload }){

    try{
        
        yield put(rs.actions.startCall({ callType: rs.callTypes.fetch }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            sessionkey: auth.sessionKey,
            input: {
                ...payload.queryParams
            }
        };

        const response = yield call(findReportsApi, reqBody);        

        if(response.status === 200){
            let reportStr = response.data;
            yield put(rs.actions.reportsFetched({ reportStr }));
        }
    }
    catch(error){

        console.log(error);

        if(error.response.status === 403){

            yield put(authReducerActions.loggedOut());
            
        } else {
            if(error.response.status === 404){

                let status = error.response.status;
                let msg = "Page Not Found.";

                yield put(uis.actions.error({ status, msg }));
            } else if(error.response.status === 500){

                let status = error.response.status;
                let msg = "Internal Error";

                yield put(uis.actions.error({ status, msg }));
            }

            yield put(uis.actions.showNotification({
                status:"error",
                title:"Error",
                message: "There was an error retrieving the reports."
            }));

            yield put(rs.actions.catchError({
                callType: rs.callTypes.fetch,
                error: "There was an error retrieving the reports."
            }));
        }
    }

};

export function* onResetReportStateStartAsync({ payload }){

    try{
        
        yield put(rs.actions.startCall({ callType: rs.callTypes.list }));

        yield put(rs.actions.reportStateClear());
 
    }
    catch(error){

        console.log(error);


        yield put(uis.actions.showNotification({
            status:"error",
            title:"Error",
            message: "There was an error with the request."
        }));
    }

};

export const actionTypes = {
    FetchReports: "[ReportsFetched] Fetch Reports API Action",
    FindReports: "[FindReports] Find Reports API Action",
    ResetReportState: "[ResetReportState] Reset Report State Action"
};

export const actions = {

    fetchReports: (deptId, queryParams) => ({ type: actionTypes.FetchReports, payload: { deptId, queryParams } }),
    findReports: (queryParams) => ({ type: actionTypes.FindReports, payload: { queryParams } }),
    resetReportState: () => ({ type: actionTypes.ResetReportState, payload: { undefined } } )

};

export function* fetchReports(){

    yield takeEvery(actionTypes.FetchReports, onLoadReportsStartAsync);    
};

export function* findReports(){

    yield takeEvery(actionTypes.FindReports,onFindReportsStartAsync);    
};

export function* resetReportState() {

    yield takeEvery(actionTypes.ResetReportState,onResetReportStateStartAsync);
};

const rsSagas = [
    fork(fetchReports),
    fork(findReports),
    fork(resetReportState)
];

export function* saga(){
    yield all ([...rsSagas]);
};
